export default {
      id: "arrow-up-right-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-up-right",
      toString: function () {
        return this.url;
      }
    }